import { APIService } from '@/core/services/APIService'
import { buildException } from '@/core/exceptions'

export class PasswordService extends APIService {
  constructor() {
    super()
  }

  requestReset(email: string): Promise<boolean> {
    return this.client
      .post('/password_reset/request', { email: email })
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  confirmReset(token: string, password: string): Promise<boolean> {
    return this.client
      .post('/password_reset/confirm', { token: token, password: password })
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  updatePassword(userId: string, currentPassword: string, newPassword: string, confirmPassword: string, token: string): Promise<boolean> {
    const data = {
      current_password: currentPassword,
      password: newPassword,
      password_confirm: confirmPassword
    }
    return this.client
      .post(`/users/${userId}/update_password`, data, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }
}
